import React, { useMemo, useState, useCallback } from "react";
const toPersian = (num) => {
  return new Intl.NumberFormat("fa-IR").format(num);
};

function useClipboard(timeout = 1600) {
  const [copied, setCopied] = useState(false);

  const copy = useCallback(
    async (text) => {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
        } else {
          const ta = document.createElement("textarea");
          ta.value = text;
          ta.style.position = "fixed";
          ta.style.left = "-9999px";
          ta.setAttribute("readonly", "");
          document.body.appendChild(ta);
          ta.select();
          document.execCommand("copy");
          document.body.removeChild(ta);
        }
        setCopied(true);
        setTimeout(() => setCopied(false), timeout);
        return true;
      } catch (e) {
        console.error("Copy failed:", e);
        return false;
      }
    },
    [timeout]
  );

  return { copied, copy };
}

function persianDate(dateIn) {
  console.log(dateIn);
  if (!dateIn) return "";
  console.log(dateIn);
  const date = new Date(dateIn);
  return new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}

export { toPersian, useClipboard, persianDate };
